var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 0H0.75C0.335786 0 0 0.335786 0 0.75V17.25C0 17.6642 0.335786 18 0.75 18H9.61436V11.0295H7.26862V8.3129H9.61436V6.30952C9.61436 3.9846 11.0343 2.71865 13.1083 2.71865C14.1018 2.71865 14.9556 2.79261 15.2044 2.82567V5.25534L13.766 5.25599C12.6381 5.25599 12.4197 5.79198 12.4197 6.5785V8.3129H15.1097L14.7595 11.0295H12.4197V18H17.25C17.6642 18 18 17.6642 18 17.25V0.75C18 0.335786 17.6642 0 17.25 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFb);
export default __webpack_public_path__ + "static/media/footer-fb.3d1af41a7942410ba55fc3fb4cfc1a7c.svg";
export { ForwardRef as ReactComponent };